import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Order} from '../classes/Order';
import {TranslateService} from '@ngx-translate/core';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class PaymentService {

  constructor(private http: HttpClient,
              private translateService: TranslateService) {}

  public async orderCheckout(orderId: number, duration: number, orderType: string): Promise<void> {

    let amount: number;
    let nameAppendix: string;
    if (orderType === 'DESK') {
      amount = 1;
      nameAppendix = '($10 per hour)';
    } else if (orderType === 'OFFICE') {
      amount = 7000;
      nameAppendix = '($70 per hour)';
    }

    const payment = {
      amount,
      currency: 'usd',
      name: 'Workplace ' + nameAppendix,
      orderId,
      quantity: duration,
      successUrl: `${environment.frontendUrl}/checkout-success`,
      cancelUrl: `${environment.frontendUrl}/checkout-cancel`,
    };

    this.http
      .post(`${environment.backendApiUrl}/v1/checkout/order`, payment, httpOptions)
      .subscribe((data: any) => window.location.assign(data.link));
  }

  public async orderYaadCheckout(order: Order): Promise<void> {

    const name = this.translateService.instant(
      'ENUM.BOOKING_OPTION_WITH_PRICE.' + order.bookingOption,
        { price: order.transaction.price }
      ) + ' (' + order.transaction.amount + '₪)';

    const payment = {
      amount: order.transaction.amount,
      currency: 'NIS',
      name,
      orderId: order.id
    };

    this.http
      .post(`${environment.backendApiUrl}/v1/checkout/order`, payment, httpOptions)
      .subscribe((data: any) => window.location.assign(data.link));
  }

  public async invoice(trxId: number): Promise<void> {
    this.http
      .get(`${environment.backendApiUrl}/v1/invoice/` + trxId, httpOptions)
      .subscribe((response: any) => {
        window.open(response.link, '_blank');
      });
  }
}
